import Vue from 'vue'
import Router from 'vue-router'
import AuthAdmin from '@/components/AuthAdmin'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/auth'
    },
    {
      path: '/auth',
      name: 'AuthAdmin',
      component: AuthAdmin
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js